import { render, staticRenderFns } from "./DlgCampaignArticleDelete.vue?vue&type=template&id=f64f4f46&scoped=true&"
import script from "./DlgCampaignArticleDelete.vue?vue&type=script&lang=js&"
export * from "./DlgCampaignArticleDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64f4f46",
  null
  
)

export default component.exports